"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var hovo_api_1 = require("../../shared/hovo-api");
var form_1 = require("../../shared/form");
var cookies_1 = require("../../shared/cookies");
var number_1 = require("../../shared/number");
(0, jquery_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () {
    function getAvailableAsContact() {
        if (!$availableAsContact.length) {
            return false;
        }
        return $availableAsContact.val() == 1;
    }
    function getDiscountCode() {
        return $discountCode.val();
    }
    function getCheckedExtras() {
        return $extraFields
            .filter(function (f, e) { return (0, jquery_1.default)(e).is(":checked"); })
            .map(function (f, e) { return parseInt((0, jquery_1.default)(e).val()); })
            .toArray();
    }
    function refreshPrice() {
        return __awaiter(this, void 0, void 0, function () {
            var discountCode, extras, rawPrice, $price;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        discountCode = getDiscountCode();
                        extras = getCheckedExtras();
                        return [4 /*yield*/, (0, hovo_api_1.calculatePrice)(courseId, discountCode, extras)];
                    case 1:
                        rawPrice = _a.sent();
                        priceCalculated = true;
                        if (rawPrice) {
                            price = parseFloat(rawPrice);
                            if (price) {
                                $paymentMethodField.parent().show();
                                $paymentMethodField.attr("required", "required");
                            }
                            else {
                                $paymentMethodField.parent().hide();
                                $paymentMethodField.removeAttr("required");
                            }
                            $price = $info.find("#price");
                            $price.text((0, number_1.formatAmount)(price));
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function pay(formData) {
        return __awaiter(this, void 0, void 0, function () {
            var method, result, idealResult, transferResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!price && !priceCalculated) {
                            return [2 /*return*/];
                        }
                        $submit.prop("disabled", true);
                        method = formData.payment_method;
                        if (!(price <= 0 && priceCalculated)) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, hovo_api_1.initFreePayment)(courseId, getAvailableAsContact(), getDiscountCode(), getCheckedExtras())];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            $form.hide();
                            (0, jquery_1.default)('#free_subscription_success_callout').show();
                        }
                        else {
                            (0, jquery_1.default)('#payment_error_callout').show();
                        }
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(method === "ideal")) return [3 /*break*/, 4];
                        return [4 /*yield*/, (0, hovo_api_1.initIdealPayment)(courseId, studentId, getAvailableAsContact(), getDiscountCode(), getCheckedExtras())];
                    case 3:
                        idealResult = _a.sent();
                        if (idealResult) {
                            (0, cookies_1.setCookie)("payment_id", idealResult.id);
                            $form.hide();
                            window.location = idealResult.url;
                        }
                        else {
                            (0, jquery_1.default)('#payment_error_callout').show();
                        }
                        return [3 /*break*/, 6];
                    case 4:
                        if (!(method === "bank_transfer")) return [3 /*break*/, 6];
                        return [4 /*yield*/, (0, hovo_api_1.initBankTransferPayment)(courseId, studentId, getAvailableAsContact(), getDiscountCode(), getCheckedExtras())];
                    case 5:
                        transferResult = _a.sent();
                        if (transferResult) {
                            $form.hide();
                            (0, jquery_1.default)('#payment_success_callout').show();
                        }
                        else {
                            (0, jquery_1.default)('#payment_error_callout').show();
                        }
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    var $info, price, priceCalculated, courseId, studentId, $form, $submit, $discountCode, $extraFields, $availableAsContact, $paymentMethodField;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                $info = (0, jquery_1.default)('#payment-information');
                if (!$info.length) {
                    return [2 /*return*/];
                }
                priceCalculated = false;
                courseId = parseInt($info.data("course-id"));
                studentId = parseInt($info.data("student-id"));
                $form = $info.find("#payment_form");
                $submit = $form.find("input[type='submit']");
                $discountCode = $form.find("#discount_code");
                $extraFields = $form.find("input[name='custom_field']");
                $availableAsContact = $form.find("#available_as_contact");
                $paymentMethodField = $form.find("select[name='payment_method']");
                $form.on("submit", function (e) {
                    return __awaiter(this, void 0, void 0, function () {
                        var formData;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    e.preventDefault();
                                    formData = (0, form_1.convertFormToJSON)($form);
                                    return [4 /*yield*/, pay(formData)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    });
                });
                $form.find(".toggler").on("click", function () {
                    var id = (0, jquery_1.default)(this).data("toggle-id");
                    var $toggle = (0, jquery_1.default)("#".concat(id));
                    if ($toggle.is(":visible")) {
                        $toggle.hide();
                    }
                    else {
                        $toggle.show();
                    }
                });
                // Calculate price when discount code is filled in.
                $discountCode.on("keyup", function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, refreshPrice()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    });
                });
                // Calculate price when extras field is checked.
                $form.find('.extras :checkbox').on("change", function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, refreshPrice()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    });
                });
                return [4 /*yield*/, refreshPrice()];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
